export enum TrustpilotWidgetTemplate {
  Mini = '53aa8807dec7e10d38f59f32',
}

//todo: use env variable with vite migration
export const TRUSTPILOT_BUSINESS_ID = '5c9e09ee89e3e2000114fe40';
